import {
    ConclusionKeys,
    FindingAreasEnum,
    getFindingAreaDisplayText,
    QuestionnaireFlowType,
    zodQuestionTypes
} from "../surveyStatusSchemas";

const questionnaireAppLevy: QuestionnaireFlowType = {
    id: FindingAreasEnum.ApprenticeshipLevy,
    name: getFindingAreaDisplayText(FindingAreasEnum.ApprenticeshipLevy),
    questions: [
        {
            id: `${FindingAreasEnum.ApprenticeshipLevy}:Q1`,
            text: "Do you have a 'pay bill' (being employment costs that are subject to Class 1 employer NIC) greater than £3m?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.ApprenticeshipLevy}:Q2A`,
                no: `${FindingAreasEnum.ApprenticeshipLevy}:Q2B`,
            },
        },
        {
            id: `${FindingAreasEnum.ApprenticeshipLevy}:Q2A`,
            text: "Do you pay the Apprenticeship Levy?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.ApprenticeshipLevy}:Q3A`,
                no: ConclusionKeys.Red,
            },
        },
        {
            id: `${FindingAreasEnum.ApprenticeshipLevy}:Q2B`,
            text: "Do you pay the Apprenticeship Levy?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.ApprenticeshipLevy}:Q3B`,
                no: `${FindingAreasEnum.ApprenticeshipLevy}:Q3C`,
            },
        },
        {
            id: `${FindingAreasEnum.ApprenticeshipLevy}:Q3A`,
            text: "Are you 'connected' with any other companies (broadly meaning one entity controls another or both are under common control, or do you have more than one PAYE scheme)?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.ApprenticeshipLevy}:Q4A`,
                no: ConclusionKeys.Green,
            },
        },
        {
            id: `${FindingAreasEnum.ApprenticeshipLevy}:Q3B`,
            text: "Are you 'connected' with any other companies (broadly meaning one entity controls another or both are under common control, or do you have more than one PAYE scheme)?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.ApprenticeshipLevy}:Q4B`,
                no: ConclusionKeys.Green,
            },
        },
        {
            id: `${FindingAreasEnum.ApprenticeshipLevy}:Q3C`,
            text: "Are you 'connected' with any other companies (broadly meaning one entity controls another or both are under common control, or do you have more than one PAYE scheme)?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.ApprenticeshipLevy}:Q4C`,
                no: ConclusionKeys.Green,
            },
        },
        {
            id: `${FindingAreasEnum.ApprenticeshipLevy}:Q4A`,
            text: "If the Apprenticeship Levy allowance is claimed in one, or multiple connected PAYE schemes, are you comfortable that the cumulative total claimed does not exceed the allowance?",
            type: zodQuestionTypes.enum.YesNoDontKnow,
            flow: {
                yes: ConclusionKeys.Green,
                no: ConclusionKeys.Red,
                dontKnow: ConclusionKeys.Red
            },
        },
        {
            id: `${FindingAreasEnum.ApprenticeshipLevy}:Q4B`,
            text: "If the Apprenticeship Levy allowance is claimed in one, or multiple connected PAYE schemes, are you comfortable that the cumulative total claimed does not exceed the allowance cap?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Green,
                no: ConclusionKeys.Red,
            },
        },
        {
            id: `${FindingAreasEnum.ApprenticeshipLevy}:Q4C`,
            text: "Is the Apprenticeship Levy allowance only claimed once across all connected PAYE schemes?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Green,
                no: ConclusionKeys.Red,
            },
        },
    ],
};

export default questionnaireAppLevy;
